import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppSummaryRowV2 } from './models/app-summary-models';
import { IoniconsOutline } from '@pt/pt-models';

@Component({
  selector: 'pt-widget-app-summary-row-rid-v2-v0',
  template: `
    <div class="app-summary-preview-row">
      <!-- WIDGET-->

      <div
        class="d-flex align-items-center flex-column warning-app-summary"
        *ngIf="row.warningMessage | async">
          {{ row.warningMessage | async }}
      </div>

      <div
        class="d-flex align-items-center flex-column w-100"
        *ngIf="row.widgetMessage | async"
      >
        <div class="legend">
          {{ row.widgetMessage | async }}
        </div>
      </div>

      <div *ngIf="row.widgetRidValue">
        <div class="chart-container">
          <div class="charts" *ngFor="let chart of row.widgetRidValue">
            <div echarts class="chart" [options]="chart.options"></div>
            <div class="value">
              <!--                        {{ chart.value }}-->
            </div>
            <div class="detail">
              <div class="label">
                {{ chart.label | async }}
              </div>
              <div class="description">
                {{ chart.description | async }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="row.showAlignBtn"
        class="d-flex align-items-center flex-column w-100"
      >
        <button
          class="btn btn-link text-link"
          [disabled]="!editable"
          (click)="alignValue.emit(row.appUUID)"
        >
          {{ 'BUTTON.UPDATE_WITH_VALUE' | translate }}
        </button>
        <pt-icon [key]="iconBackArrow" [size]="30"></pt-icon>
      </div>

      <div
        *ngIf="row.showRemoveBtn"
        class="d-flex align-items-center flex-column w-100"
      >
        <button
          class="btn btn-link text-link"
          [disabled]="!editable"
          (click)="alignValue.emit(row.appUUID)"
        >
          {{ 'BUTTON.REMOVE_WITH_VALUE' | translate }}
        </button>
      </div>

      <!-- APP VALUE-->

      <div
        class="d-flex align-items-center flex-column w-100"
        *ngIf="row.appMessage | async"
      >
        <div class="legend">
          {{ row.appMessage | async }}
        </div>
      </div>

      <div *ngIf="row.appRidValue">
        <div class="chart-container">
          <div class="charts" *ngFor="let chart of row.appRidValue">
            <div echarts class="chart" [options]="chart.options"></div>
            <div class="value">
              <!--                        {{ chart.value }}-->
            </div>
            <div class="detail">
              <div class="label">
                {{ chart.label | async }}
              </div>
              <div class="description">
                {{ chart.description | async }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: [`widget-app-summary-preview-v0.component.scss`],
})
export class WidgetAppSummaryRowRidV2V0Component {
  @Input() row: AppSummaryRowV2;
  @Input() editable = false;
  iconBackArrow = IoniconsOutline.arrowDownOutline;

  @Output() alignValue = new EventEmitter<string>();
}
